module.exports = __webpack_public_path__ + "static/media/mobiziac.987c6635.jpg";